export default "__VITE_ASSET__KdLrdyyi__"